import { useSearchParams } from 'react-router-dom';
import ErrorMessage from '../components/common/ErrorMessage';

export default function OAuthErrorPage() {
  const [searchParams] = useSearchParams();
  const error = searchParams.get('error') || 'Ein unbekannter Fehler ist aufgetreten.';

  return (
    <div className="flex items-center justify-center py-16">
      <ErrorMessage
        title="Verbindung fehlgeschlagen"
        message={`Die Verknüpfung mit dem Microsoft-Konto ist fehlgeschlagen: ${error}`}
      />
    </div>
  );
}
